export function tomanToRial(price: number, rialExchange: number): number {
  return rialExchange * price;
}

export function rialToToman(price: number, rialExchange: number): number {
  return price / rialExchange;
}
